import { IconProps } from "@/data/types"

export default function DiningIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32" enableBackground="new 0 0 32 32"  width={width} height={height} fill={color}>
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> 
          <line fill="none" stroke={color} strokeWidth="0.992" strokeMiterlimit="10" x1="5" y1="27" x2="13.5" y2="18.5"></line> 
          <line fill="none" stroke={color} strokeWidth="0.992" strokeMiterlimit="10" x1="16" y1="16" x2="25.2" y2="6.8"></line> 
          <line fill="none" stroke={color} strokeWidth="0.992" strokeMiterlimit="10" x1="27" y1="27" x2="14" y2="14"></line> 
          <path fill="none" stroke={color} strokeWidth="0.992" strokeMiterlimit="10" d="M17.9,17.9l-2.5,2.5l-8.9-8.9c-1.4-1.4-1.4-3.6,0-5 l0,0L17.9,17.9z"></path> 
          <path fill="none" stroke={color} strokeWidth="0.992" strokeMiterlimit="10" d="M27.3,8.9l-4.6,4.6c-0.8,0.8-2,0.8-2.8,0l-1.4-1.4 c-0.8-0.8-0.8-2,0-2.8l4.6-4.6"></path> 
        </g>
      </svg>
    </div>
  )
}